import React, { useEffect, useState } from "react";
import ScreenContainer from "../../Components/ScreenContainer";
import CustomOverviewMain from "./CustomOverviewMain";
import Loader from "../../Helper/Loaders/Loader";
import { getPagesMetaData } from "../../Api/Api";
import AppCache from "../../Helper/Common/AppCache";
import CODE from "../../Static/Constants/StatusCodes";

/**
 * CustomDashboard — entry point for custom dashboard routes (e.g. /custom-observability).
 *
 * Fetches pagesContent from the same /api/pages/metadata endpoint used by the
 * Coulomb overview so that PagesContentContext (entity labels, org config) is
 * populated for all child components (GlobalFilter, useBaseEntityInfo, etc.).
 */
function CustomDashboard() {
    const [pageContent, setPageContent] = useState({ mounted: false });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchPageData = async () => {
            // Read from cache first — CustomInventoryPage reuses the same data
            const cached = AppCache.getItem("fleetHomePageContent");
            if (cached) {
                setPageContent(cached);
                setIsLoading(false);
                return;
            }
            const res = await getPagesMetaData("fleetHomePage");
            if (res?.responseStatus?.code === CODE.SUCCESS) {
                const data = res.response?.response;
                AppCache.setItem("fleetHomePageContent", data);
                setPageContent(data);
            }
            setIsLoading(false);
        };
        fetchPageData();
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <ScreenContainer pagesContent={pageContent}>
            <CustomOverviewMain />
        </ScreenContainer>
    );
}

export default CustomDashboard;
